var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("email")))]),
              _c(
                "w-list",
                [
                  _vm._l(_vm.emailTemplates, function (template) {
                    return _c(
                      "w-list-item",
                      { key: template.ID },
                      [
                        _c("w-list-item-text", [_vm._v(_vm._s(template.Name))]),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.editEmailTemplate(template)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "pen" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                staticClass: "danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteEmailTemplate(template)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "w-list-item",
                    [
                      _c(
                        "w-list-item-text",
                        [
                          _c(
                            "w-link",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.newEmailTemplate()
                                },
                              },
                            },
                            [
                              _c("w-fa", { attrs: { icon: "plus" } }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$ct("new-email-template")) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }